import axios from "axios";
import jwtDecode from "jwt-decode";

export async function getToken({ commit }, user) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Iniciando sesión",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/token/", user)
      .then((response) => {
        const data = response["data"];
        const tokenAccess = data["access"];
        const tokenRefresh = data["refresh"];
        const decoded = jwtDecode(tokenAccess);
        const name = decoded["name"];
        const username = decoded["username"];
        const email = decoded["email"];
        const last_name = decoded["last_name"];
        const isObipetsAdmin = decoded["isObipetsAdmin"];
        const phone_number = decoded["phone_number"];
        const id = decoded["id"];
        const newuser = decoded["newuser"];
        commit("setUserData", {
          tokenAccess,
          tokenRefresh,
          email,
          isObipetsAdmin,
          username,
          name,
          phone_number,
          last_name,
          id,
          newuser,
        });
        resolve(response);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// eslint-disable-next-line
export async function signup({ commit }, data) {
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Bienvenido!",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .post("/auth/signup/", data)
      .then((data) => {
        if (data.status === 201) {
          resolve(data);
        }
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function setUserInf({ commit }, { formData, username }) {
  const url = `/users-profile/${username}/`;
  // Set loading page animation
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Actualizando Datos",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .put(url, formData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// eslint-disable-next-line
export async function getUserProfile({ commit }, username) {
  const url = `/users-profile/${username}/`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}

// noinspection JSUnusedGlobalSymbols
export async function refreshToken({ commit, state }) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Iniciando sesión",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/token/refresh/", { refresh: state.tokenRefresh })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// eslint-disable-next-line object-curly-newline
export async function logout({ commit }) {
  commit("logout");
}

// eslint-disable-next-line no-unused-vars
export async function tokenVerify({ commit }, data) {
  return new Promise((resolve, reject) => {
    axios
      .post("/auth/token-verify/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}

// eslint-disable-next-line no-unused-vars
export async function tokenVerifyForResetPass({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Cargando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/token-4resetpass/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// eslint-disable-next-line no-unused-vars
export async function updatePassword({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Actualizando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/update-password/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// eslint-disable-next-line no-unused-vars
export async function sendEmail4ResetPass({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Enviado E-mail",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .post("/auth/send-email-resetpass/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// Todo para Email

export async function tokenVerifyForResetEmail({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Cargando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/token-4resetEmail/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

// eslint-disable-next-line no-unused-vars
export async function updateEmail({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Actualizando datos",
    },
    { root: true }
  );

  return new Promise((resolve, reject) => {
    axios
      .post("/auth/update-email/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}

export async function sendEmail4ResetEmail({ commit }, data) {
  commit(
    "setLoading",
    {
      isLoading: true,
      msg: "Enviado E-mail",
    },
    { root: true }
  );
  return new Promise((resolve, reject) => {
    axios
      .post("/auth/send-email-resetemail/", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      })
      .finally(() => {
        commit("setLoading", { isLoading: false, msg: "" }, { root: true });
      });
  });
}